
import ConfigService from "./ConfigService";
import HttpService from "./HttpService";
import AuthService from "./AuthService";
import JavascriptHelpers from "../components/lib/Javascript/JavascriptHelpers";
import IdentityService from "./IdentityService";

import _ from "lodash";

import { formatISO, parseISO, format } from "date-fns";
import JwtToken from "../components/lib/tokens/JwtToken";
import { AppSecurityKey } from "../models/AppSecurityKey";
import RoleManager from "../models/RoleManager";

import SummaryBatchSearchParams from "../models/SummaryBatchSearchParams";
import TelemetrySearchParams from "../models/TelemetrySearchParams";

export default class CoreService 
{
  constructor(coreDomain) 
  {
    this.configService = new ConfigService();
    this.domain = coreDomain || this.configService.getCoreServiceHost();
    this.authService = new AuthService();
  }

  getMockResult(dataResult, statusCode=200)
  {
    var result = {"httpStatusCode": statusCode, "hasError": false, "messages": ["Mock Result."], "isRecordNotFound":  false, "dataResult": dataResult};
    return result;
  }

  async fetchVersion(token) 
  {
    const path = "/api/admin/version";
    var response = await HttpService.get(this.domain, path, token);
    //var dataResult = {"os": "mock", "coreVersion": "mock", "appVersion": "mock", "lastBuild": "mock"};
    //var response = this.getMockResult(dataResult);
    return response;
  }

  async pingCore(token) 
  {
    const path = "/api/admin/ping";
    var response = await HttpService.get(this.domain, path, token);
    // MOCK RESPONSE
    //var response = this.getMockResult("ping!");
    return response;
  }

  async pingCoreDb(token)
  {
    const path = "/api/adapter/ping/coredb";
    var response = await HttpService.get(this.domain, path, token);
    // MOCK RESPONSE
    //var response = this.getMockResult("ping!");
    return response;
  }

  async fetchOrgConfiguration(gcid, token)
  {
    const path = "/api/config/gcid/" + gcid + "/supplierconfig";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }


  async fetchSummaryBatchList(searchParams, gcid, token)
  {
    var queryString = SummaryBatchSearchParams.toSearchKey(searchParams);
    const path = "/api/dashboard/app/itrace/gcid/" + gcid + "/batchsummary?" + queryString;
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }


  async fetchSummaryBatchListBySearch(gcid, token, count){
    const path = "/api/dashboard/app/itrace/gcid/" + gcid + "/batchsummary?maxcount=" + count;
    let response = await HttpService.get(this.domain, path, token);
    return response;
  }


  async fetchSummaryBatchTree(batchId, gcid, token)
  {
    const path = "/api/dashboard/app/itrace/gcid/" + gcid + "/batchdocumentuinode/batchid/" + batchId;
    let response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async fetchBatchDocumentByTransactionId(transactionId, gcid, token)
  {
    const path = "/api/dashboard/app/itrace/gcid/" + gcid + "/batchdocument/transactionid/" + transactionId;
    let response = await HttpService.get(this.domain, path, token);
    return response;
  }



  async fetchIdNameMetaDataList(gcid, token)
  {
    const path = "/api/datalist/gcid/" + gcid + "/datalistmetadata?storageschema=IdNameData";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }



  async fetchIdNameDataList(dataListName, gcid, token)
  {
    const path = "/api/datalist/gcid/" + gcid + "/idnamedatalist/" + dataListName;
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async postIdNameDataList(dataList, gcid, token)
  {
    const path = "/api/datalist/gcid/" + gcid + "/idnamedatalist";
    var jsonObj = JSON.stringify(dataList);
    var response = await HttpService.postJson(this.domain, path, token, jsonObj);
    return response;
  }

  async postIdNameDataListDeleteRequest(listName, gcid, token)
  {
    const path = "/api/datalist/gcid/" + gcid + "/datalistdeleterequest/" + listName;
    var response = await HttpService.postJson(this.domain, path, token, "{}");
    return response;
  }

  async fetchZipDownload(batchId, gcid, token)
  {
    const path = "/api/dashboard/app/itrace/gcid/" + gcid + "/batchdocument/postedbodyzip/batchid/" + batchId;
    var url = this.domain + path;
    var fileName = batchId + ".zip";
    var response = await HttpService.downloadFile(url, fileName, token);
    return response;
  }



  async fetchErrorLogList(eventType, iso8601StartDateTime, gcid, token)
  {
    const path = "/api/errorlog/gcid/" + gcid + "/errorevent?maxCount=20&startDate=" + iso8601StartDateTime + "&eventtype=" + eventType;
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async fetchBatchStatusByHour(daysOld, gcid, token)
  {
    const path = "/api/dashboard/gcid/" + gcid + "/postresultbyhour/daysold/" + daysOld + "?status=all";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async fetchBatchStatusBySearch(searchParams, schemaSearch, gcid, token)
  {
    var searchParamsObj = SummaryBatchSearchParams.toApiSearchObject(searchParams, schemaSearch);
    var obj = JSON.stringify(searchParamsObj);
    const path = "/api/dashboard/gcid/" + gcid + "/postresultbyhour/search/";
    var response = await HttpService.postJson(this.domain, path, token, obj);
    return response;
  }

  async repostBatchSummary(batchId, gcid, token)
  {
    const path = "/api/adapter/app/itrace/gcid/" + gcid + "/shipment/batchid/" + batchId + "/repostrequest"
    var response = await HttpService.postJson(this.domain, path, token, "{}");
    return response;
  }



  async fetchUserImgSasUri(imgId, ext, gcid, token) 
  {
    const path = "/api/storage/gcid/" + gcid + "/upload/uri/userimage/id/" + imgId + "/ext/" + ext;
    let sasUriResponse = await HttpService.get(this.domain, path, token);
    return sasUriResponse;
  }

  async fetchUserDocSasUri(docId, ext, gcid, token) 
  {
    const path = "/api/storage/gcid/" + gcid + "/upload/uri/userdoc/id/" + docId + "/ext/" + ext;
    let sasUriResponse = await HttpService.get(this.domain, path, token);
    return sasUriResponse;
  }




  // Subscriptions

    async fetchSubscriptionOrgSchema(subscriptionId, gcid, token)
    {
      const path = "/api/subscriber/gcid/" + gcid + "/subscriptionorgschema/subscriptionid/" + subscriptionId;
      let response = await HttpService.get(this.domain, path, token);
      if (response.hasError)
      {
        return response;
      }
      // let's go ahead and parse the schemas
      var parsedDataResult = JSON.parse(response.dataResult.snapshot);
      response.dataResult = parsedDataResult;
      return response;
    }

    async fetchSubscribersByForeignPropValue(subscriptionId, propName, propValue, gcid, token)
    {
      const path = "/api/subscriber/gcid/" + gcid + "/subscriptionsubscriberschema/subscriptionid/" + subscriptionId + "/propname/" + propName + "/propval/" + propValue;
      let response = await HttpService.get(this.domain, path, token);
      return response;
    }

    async fetchSubscriberList(gcid, token, ignoreActiveFlag = true)
    {
      var ignoreActiveFlagQueryString = (ignoreActiveFlag) ? "?ignoreactiveflag=true" : "?ignoreactiveflag=false";
      const path = "/api/subscriber/gcid/" + gcid + "/subscriptionsubscriberschema" + ignoreActiveFlagQueryString;
      let response = await HttpService.get(this.domain, path, token);
      if (response.hasError)
      {
        return response;
      }
      // let's go ahead and parse the schemas
      var parsedDataResult = response.dataResult.map((d) => JSON.parse(d.snapshot));
      response.dataResult = parsedDataResult;
      return response;
    }

    async postSubscriber(subscriber, gcid, token)
    {
      const path = "/api/subscriber/gcid/" + gcid + "/subscriptionsubscriberschema";
      subscriber.snapshot = JSON.stringify(subscriber);
      //var postObj = JSON.stringify(subscriber);
      var response = await HttpService.postJson(this.domain, path, token, subscriber);
      if (response.hasError) return response;
      return response;
    }


    //note that this is the subscriber id - the guid - not the subscriber name
    async removeSubscriber(id, gcid, token)
    {
      const path = "/api/subscriber/gcid/" + gcid + "/subscriptionsubscriberschemadeleterequest/id/" + id;
      var postObj = "{}";
      var response = await HttpService.postJson(this.domain, path, token, postObj);
      return response;
    }

    async postSubscriberNotificationTestMessages(subscriber, gcid, token)
    {
      const path = "/api/notification/app/itrace/gcid/om/test";
      var postObj = {};
      if (subscriber.transportInfo?.email?.address)
      {
        postObj["Email"] = {
            Address: subscriber.transportInfo.email.address, //"curt.sorkin@glassbit.com",
            Subject: "Test Email from Glassbit ItemTracer",
            Message: "This is a test email from the Glassbit ItemTracer subscriber maintenance system"
        };
      }
      if (subscriber.transportInfo?.sms?.address)
      {
        postObj["Sms"] =  {
            Address: subscriber.transportInfo?.sms.address, //"+18312529097",
            Message: "This is a test text from the Glassbit ItemTracer subscriber maintenance system"
        };
      }
      var response = await HttpService.postJson(this.domain, path, token, postObj);
      return response;
    }

  // end Subscriptions


  // begin Proxy API

  async fetchApiProxyUrl(host, endpointPath, gcid, token)
  {
    let response = await HttpService.get(host, endpointPath, token);
    return response;
  }

  // end Proxy API



  // Error Events

  async postErrorEvent(errorEvent, gcid, token)
  {
    const path = "/api/errorlog/gcid/" + gcid + "/erroreventpostrequest";
    var postObj = errorEvent;
    let response = await HttpService.postJson(this.domain, path, token, postObj);
    return response;
  }

  // end Error Events






  // Telemetry Events


  async fetchTelemetryEventList(gcid, token)
  {
    var searchParams = new TelemetrySearchParams();
    searchParams.gcid = gcid;
    searchParams.maxCount = 100;
    let qString = searchParams.toQueryString();
    const path = '/api/dashboard/app/itrace/gcid/' + gcid + '/telemetry/polling';
    var url = path + "?" + qString;
    let response = await HttpService.get(this.domain, url, token);
    return response;
  }

  // end Telemetry Events


  // Item Tracer Dashboard API
  async fetchActivityBarChartData(gcid, token){
    const path = "/api/dashboard/app/itrace/gcid/" + gcid + "/postresultbyhour/daysold/30";
    let response = await HttpService.get(this.domain, path, token);
    return response;
  }


 



  
}